import React from "react";
import axios from "axios";
import { BASE_URL, OPPORTUNITIES, HEADERS } from "../../common/api";
import Table from "../../assets/js/Table";
import { Modal, Form, Button } from "react-bootstrap";
import Error from "../../assets/js/Error";

const columns = [
  { field: "image", header: "Фото" },
  { field: "link", header: "Ссылка" },
  {field: "nameUz", header: "Nomlanishi Uz"},
  {field: "nameRu", header: "Наименование Ru"},
  { field: "priority", header: "Приоритеты" },
  { field: "isActive", header: "Статусы" },
];

export default class Banner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      opportunities: [],
      nameUz: "",
      nameRu: "",
      link: "",
      priority: 1,
      image: null,
      id: "",
      isActive: true,
      status: 0,
    };
    this.showModal = this.showModal.bind(this);
    this.addOrUpdate = this.addOrUpdate.bind(this);
    this.renewState = this.renewState.bind(this);
    this.get = this.get.bind(this);
    this.delete = this.delete.bind(this);
    this.getTitle = this.getTitle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onImageChange = this.onImageChange.bind(this);
    this._isMounted = false;
  }

  renewState = () => {
    this.setState({
      show: false,
      nameUz: "",
      nameRu: "",
      link: "",
      priority: 1,
      image: null,
      id: "",
      isActive: true,
    });
  };
  // Show or hide modal depending on show state
  // setState sets default values in order to erase state after every modal show
  showModal = () => {
    this.setState({ show: true });
  };

  hideModal = () => {
    this.setState({ show: false });
    this.renewState();
  };

  // Handle change in event
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };
  // Image handle
  onImageChange = (event) => {
    this.setState({ image: event.target.files[0] });
  };
  // TITLE change
  getTitle = () => {
    const { id } = this.state;
    if (id) {
      return <h3>Изменить</h3>;
    } else {
      return <h3>Добавить новый</h3>;
    }
  };

  // GET data
  componentDidMount() {
    this._isMounted = true;
    this._isMounted &&
      axios
        .get(BASE_URL + OPPORTUNITIES, HEADERS)
        .then((res) => {
          this._isMounted &&
            this.setState({ opportunities: res.data, status: res.status });
        })
        .catch((err) => {
          this._isMounted && this.setState({ status: err.response.status });
        });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  // GET data depending on id in order to edit it
  get = (row) => {
    this.showModal();
    this.setState({
      nameUz: row.nameUz,
      nameRu: row.nameRu,
      link: row.link,
      priority: row.priority,
      image: row.image,
      id: row.id,
      isActive: row.isActive,
    });
  };

  // DELETE data
  delete = (id, event) => {
    if (event) {
      event.preventDefault();
    }
    const { opportunities } = this.state;
    axios.delete(BASE_URL + OPPORTUNITIES + id, HEADERS).then((res) => {
      const updatedData = opportunities.filter((banner) => banner.id !== id);
      this.setState({ opportunities: updatedData });
    });
  };

  
  // POST or UPDATE data
  // Function collects all inputs and depending on whether id is exist or not, decides put or post
  addOrUpdate = (event) => {
    event.preventDefault();
    const { nameUz, nameRu, image, id, link, priority, opportunities, isActive } = this.state;

    let formData = new FormData();
    if (image !== null && image.name) {
      formData.append("image", image, image.name);
    }
    formData.append("nameUz", nameUz);
    formData.append("nameRu", nameRu);
    formData.append("link", link);
    formData.append("priority", priority);
    formData.append("isActive", isActive);
    if (id) {
      axios
        .patch(BASE_URL + OPPORTUNITIES + id + "/", formData, HEADERS)
        .then((res) => {
        const index = opportunities.findIndex((item) => item.id === id);
        opportunities[index] = res.data;
        this.setState({ opportunities });
        this.hideModal();
        }).catch((error) => {
          console.log(error.response);
        });
    } else {
      axios
        .post(BASE_URL + OPPORTUNITIES, formData, HEADERS)
        .then(
          (res) =>
            this.setState({ opportunities: [...this.state.opportunities, res.data] }),
          this.renewState()
        )
        .catch((error) => {
          console.log(error.response);
        });
    }
  };

  render() {
    const {
      opportunities,
      nameUz,
      nameRu,
      link,
      priority,
      isActive,
      show,
      id,
      status,
    } = this.state;
    if (!opportunities) {
      return null;
    }
    return (
      <>
        {status === 200 ? (
          <>
            <Modal
              show={show}
              onHide={() => {
                this.hideModal();
              }}
              animation={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>{this.getTitle()}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form onSubmit={(event) => this.addOrUpdate(event)}>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlInput1"
                    key={id}
                  >
                    <Form.Label>Nomlanishi Uz:</Form.Label>
                    <Form.Control
                      type="text"
                      name="nameUz"
                      value={nameUz}
                      onChange={this.handleChange}
                    />
                    <Form.Label>Наименование Ru:</Form.Label>
                    <Form.Control
                      type="text"
                      name="nameRu"
                      value={nameRu}
                      onChange={this.handleChange}
                    />
                    <Form.Label>Ссылка</Form.Label>
                    <Form.Control
                      type="text"
                      name="link"
                      value={link}
                      onChange={this.handleChange}
                    />
                    <Form.Label>Приоритеты</Form.Label>
                    <Form.Control
                      type="number"
                      name="priority"
                      value={priority}
                      onChange={this.handleChange}
                    />
                    <Form.Label>Фото:</Form.Label>
                    <Form.Control
                      type="file"
                      name="image"
                      onChange={this.onImageChange}
                    />
                    <Form.Label>Статусы:</Form.Label>
                    <Form.Control
                      as="select"
                      onChange={this.handleChange}
                      name="isActive"
                      value={isActive}
                    >
                      <option value="true">Актив</option>
                      <option value="false">Пассив</option>
                    </Form.Control>
                  </Form.Group>
                  <Button
                    variant="primary"
                    type="submit"
                    onClick={this.showModal}
                  >
                    Сохранить
                  </Button>
                </Form>
              </Modal.Body>
            </Modal>
            <Table
              addFunc={this.showModal}
              data={opportunities}
              columns={columns}
              title="Преимущества"
              editFunc={(row) => this.get(row)}
              deleteFunc={(id, event) => this.delete(id, event)}
            />
          </>
        ) : (
          <Error status={status} />
        )}
      </>
    );
  }
}
